import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { I18nModule } from 'app/shared/i18n/i18n.module';
import { CurrencyFormatterPipeModule } from 'app/shared/currency-formatter-pipe/currencyFormatterPipe.module';
import { DxPieChartModule, DxSliderModule, DxChartModule } from 'devextreme-angular';
import { ChartsModule } from 'ng2-charts';
import { PdfProgramStatusReportComponent } from 'app/programs/program-detail/pdf-program-status-report/pdf-program-status-report.component';
import { ShortNumberPipeModule } from 'app/shared/short-number-pipe/short-numberPipe.module';

@NgModule({
  imports: [
    CommonModule,
    CurrencyFormatterPipeModule,
    DxPieChartModule,
    DxSliderModule,
    DxChartModule,
    ChartsModule,
    I18nModule,
    ShortNumberPipeModule
  ],
  declarations: [
    PdfProgramStatusReportComponent
  ],
  exports: [
    PdfProgramStatusReportComponent
  ]
})

export class PDFProgramStatusReportModule { }